var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { XBox } from '../box/XBox';
import { XIcon } from '../icon/XIcon';
import { XSection } from './XSection';
export function XSectionHeader(_a) {
    var linkBack = _a.linkBack, title = _a.title, buttonsElement = _a.buttonsElement, rest = __rest(_a, ["linkBack", "title", "buttonsElement"]);
    var hasUpperRow = Boolean(linkBack);
    return (React.createElement(XSection, __assign({}, rest, { className: clsx(rest.className, 'XSectionHeader') }),
        hasUpperRow && (React.createElement(XBox, { flex: true, justify: "space-between", className: "row-upper" },
            React.createElement(XBox, { flex: true, align: "center" }, linkBack && React.createElement(XIcon, null, "arrow_back")),
            React.createElement(XBox, { flex: true, gap: 1 }, buttonsElement))),
        React.createElement(XBox, { flex: true, align: "center", justify: "space-between" },
            React.createElement("div", { className: "title" }, title),
            React.createElement(XBox, { flex: true, gap: 1 }, !hasUpperRow && buttonsElement))));
}
